import { TelemetryErrorData } from '../shared/interfaces';

export const analyticsConstants = {
	APP_NAME: 'olci',
	CHANNEL: 'olci',
  DEFAULT_COUNTRY: 'USA',
  DEFAULT_LANGUAGE: 'en',
  DEFAULT_CURRENCY: 'USD',
  SITE_TYPE: 'responsive',
  INTERACTION_EVENT_TYPE: 'interaction',
  ALERT_EVENT_TYPES: {
		PASSPORT_MESSAGE:
			// tslint:disable-next-line: max-line-length
			'alert: Royal Caribbean International strongly recommends that all guests travel with a document that is valid for at least 6 months beyond the end of the cruise.',
		EXPENSE_ACCOUNT: 'alert: expense account: complete all information for every guest in order to continue to the next section'
	},
	ERROR_EVENT_TYPES: {
		REQUIRED: 'the information is required',
		MIN_CHARS_5: 'value must be at least 5 characters',
		MIN_CHARS_6: 'value must be at least 6 characters',
		MAX_CHARS_9: 'value must be at most 9 characters',
		MAX_CHARS_12: 'value must be at most 12 characters',
		MAX_CHARS_25: 'value must be at most 25 characters',
		NO_SPECIAL_CHARS: 'no special characters allowed',
		INVALID_DOC_NUMBER: 'please enter a valid document number',
		INVALID_DATE: 'invalid date',
		DOC_EXPIRATION_DATE: 'your travel document must be valid for the entire length of the cruise plus two days',
		SELECTED: 'a value must be selected',
		ADDRESS_CHARS: 'use numbers, letters, dashes, #, dots and spaces',
		CITY_CHARS: 'use letters, numbers, dashes and spaces only',
		NUMBERS_ONLY: 'use numbers only',
		CHARS_SPACE_ONLY: 'use letters and spaces only',
    MOBILE_NUMBER_INVALID: 'Please check the number and try again.',
	},
	PAY_METHOD_EVENT_TYPES: {
		PROJECT: 'olci',
		PAY_METHOD: 'payMethod',
		UPDATE_CARD: 'updateCard',
		CREDIT_CARD: 'CreditCard',
		CASH: 'cash',
		NO_CHARGING: 'none',
		GRANTOR_CARD: 'grantor credit card',
		REPLACE_SAVED_CARD: 'replacesavedcard'
	},
	YES_NO_NA: {
		YES: 'Y',
		NO: 'N',
		NA: 'NA'
	},
	TRACKING_SECTIONS: {
		ONBOARD_EXPENSES: 'onboardexpenses',
	},
	PAYWAY_CARD_SAVED: {
		GRANTOR_CARD: 'Y',
		NEW_CARD: 'N',
		OTHER: 'NA',
		SAVED_CARD: 'S',
		NOT_SAVED_CARD: 'NS'
	},
	PAYWAY_INPUT_METHOD: {
		MANUAL: 'Manual',
		NOT_APPLICABLE: 'NA'
	},
	PAYWAY_FORM_FIELDS_NAME: {
		NAME: 'pgcreditcardHolderName',
		NUMBER: 'pgcreditcardNumber',
		EXPIRATION_DATE: 'pgcreditcardExpirationDate',
		SECURITY_CODE: 'pgcreditcardSecurityCode',
		ZIP_CODE: 'pgcreditcardZipCode',
	},
	GUEST_STATUS: {
		COMPLETED: 'olci:CompletedGuest',
		IN_PROGRESS: 'olci:InProgressGuest'
	},
	BOOKING_STATUS: {
		BROWSE: 'Browse',
		NEW_TO_CRUISE: 'New_to_Cruise'
	},
	USER_TYPE: {
		REPEAT: 'Repeat',
		NEW: 'New'
	},
  SELECT_FOR_CHECKIN: {
    INTERACTION: 'checkin:selectforcheckin',
    CURRENT_PAGE: 'selectforcheckin',
  },
  BOOKING_TYPES: {
    DEFAULT: '',
    CONSTANTS: {
      'VP': 'website',
      'TA': 'travel agent',
    }
  },
  BRAND_TYPES: {
    DEFAULT: 'RCI',
    CONSTANTS: {
      'C': 'CEL',
      'Z': 'AZA',
    }
  },
  FLOW_EVENTS: {
    START_FLUID_VARIABLE: 'olciStart',
    START_INTERACTION: 'olci:start',
    START_PAGE_NAME: 'olci:selectforcheckin',
    COMPLETE_FLUID_VARIABLE: 'olciComplete',
    COMPLETE_INTERACTION: 'checkin:complete',
    COMPLETE_PAGE_NAME: 'olci:confirmation',
    SAVE_CARD_FLUID_VARIABLE: 'saveCard',
    SAVE_CARD_INTERACTION: 'olci:addPaymentMethod',
    SAVE_CARD_PAGE_NAME: 'olci:onboardexpenses',
  },
  CRUISE_DETAILS: {
    CURRENT_PAGE: 'guest:cruisedetails',
    INTERACTION: 'checkin:cruisedetails',
    MESSAGES: {
      CONTRACT_INFORMATION: 'You must select the checkbox above to continue.',
      SELECT_A_COUNTRY: 'You must select a country above to continue.',
      MODAL_EMAIL_CTC: 'modal:cruiseDetails:emailCtc',
      MODAL_EMAIL_CTC_SEND_BUTTON: 'modal:cruise details:email ctc - send button',
      PRIMARY_COUNTRY_OF_RESIDENCE: 'primary country of residence|You must select a country above to continue.'
    }
  },
  GUEST_DETAILS: {
    PAGE_NAME: 'olci:guestdetails',
    GUEST_PHOTO_FLUID_VARIABLE: 'guestPhoto',
    CURRENT_PAGE: 'olci:guestdetails',
    INTERACTION: 'checkin:errorMessage:inlineError',
    MESSAGES: {
      COMPLETE_INFORMATION: 'Complete all information for every guest in order to continue to the next section.',
    }
  },
  ONBOARD_EXPENSES: {
    CURRENT_PAGE: 'onboardexpenses',
    INTERACTION: 'guest:onboardexpenses',
    MESSAGES: {
      UNABLE_TO_RETRIEVE_CARD: 'Sorry, we hit a snag. We\'re unable to retrieve your credit card information. Please try again later.',
      UNABLE_TO_COMPLETE_REQUEST: 'Sorry, we hit a snag. We\'re unable to complete your request. Please try again later.',
      CARD_TRANSACTION_DECLINED: 'Hmm, make sure the card information is correct or try using a different card.',
    },
    PAY_METHOD: {
      FLUID_VARIABLE: 'payMethod',
      INTERACTION: 'olci:addPaymentMethod',
      PAGE_NAME: 'olci:onboardexpenses',
    },
    ADD_NEW_INVALID_CC: {
      PAGE_NAME: 'olci:onboardexpenses',
      INTERACTION: 'olci:errorMessage:inlineError',
    }
  },
  CRUISE_CONTRACT: {
    CURRENT_PAGE: 'cruise-contracts',
    INTERACTION: 'checkin:cruisecontracts',
    MESSAGES: {
      ADULTS_IN_PARTY: 'cruise contracts: please have an adult in your party complete check-in',
    }
  },
  CHECKIN_COMPLETED: {
    CURRENT_PAGE: 'cruise-contracts',
    INTERACTION: 'checkin:cruisecontracts',
  },
  ADVERTISEMENT: {
    CURRENT_PAGE: 'setsailpass',
    INTERACTION: 'boarding pass:retailmediaclick',
    INTERNAL_CAMPAIGN: 'retailmedia'
  },
  MESSAGE_CENTER: {
    PANEL_TYPE: 'web:MCnotifications',
    LOCAL_STORAGE_KEY_CRUISE_PLANNER: 'ga/cruisePlannerOrigin'
  },
  GENERIC_TELEMETRY_ERROR_DATA: { message: 'Unknown Error', lookup: 'GC-000-UNKNOWN' } as TelemetryErrorData
};
